import { makeStyles, } from '@material-ui/core/styles';

export type PointerStyle = {
    option?: string,
};

export const makePointerStyles = makeStyles({
    root: ({ option = 'pointer', }: PointerStyle = {}) => ({ cursor: option, }),
});

export const makeGenericStyles = makeStyles({
    root: props => ({ ...props, }),
}, { index: 1, });
